export const STAFF_AREAS = { news_editor: ["news"], match_officer: ["matches"], data_manager: ["data"] };

export const ROLE_LABELS = { admin: "Full Admin", news_editor: "News Editor", match_officer: "Match Officer", data_manager: "Data Manager" };

export const isStaff = (user) => !!user && (user.role === "admin" || user.role in STAFF_AREAS);

// area: undefined = full admin only, "staff" = any staff, "super" = super admin
export const canAccess = (user, area) => {
  if (!user) return false;
  if (area === "super") return user.role === "admin" && !!user.is_super_admin;
  if (user.role === "admin") return true;
  if (area === "staff") return isStaff(user);
  return !!area && (STAFF_AREAS[user.role] || []).includes(area);
};
